<template>
  <section class="text-center">
    <div class="max-w-3xl mx-auto bg-gradient-to-r from-psychology-primary to-psychology-secondary rounded-3xl p-12 text-white shadow-2xl">
      <div class="text-6xl mb-6">💕</div>
      <h2 class="text-4xl font-bold mb-4">准备发现你的恋爱倾向了吗？</h2>
      <p class="text-lg mb-8 opacity-90">
        通过科学的四维度心理学模型，精准评估你的年上年下倾向，深入了解你的恋爱人格和依恋模式。
      </p>
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <button
          @click="handleStartAssessment"
          class="px-8 py-4 bg-white text-psychology-primary rounded-lg font-bold text-lg hover:bg-gray-100 transition-all hover:shadow-xl inline-flex items-center gap-3 justify-center"
        >
          <span class="text-2xl">💝</span>
          <span>立即开始测试</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
        <router-link 
          to="/guide" 
          class="px-8 py-4 border-2 border-white text-white rounded-lg font-bold text-lg hover:bg-white/10 transition-all inline-flex items-center gap-3 justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          </svg>
          了解更多
        </router-link>
      </div>
    </div>

    <!-- 激活码验证对话框 -->
    <ActivationCodeDialog 
      :show="showActivationDialog"
      :target-route="targetRoute"
      @close="handleActivationClose"
    />
  </section>
</template>

<script>
import { isActivated } from '@/utils/activationUtils'
import ActivationCodeDialog from './ActivationCodeDialog.vue'

export default {
  name: 'CTASection',
  components: {
    ActivationCodeDialog
  },
  data() {
    return {
      showActivationDialog: false,
      targetRoute: ''
    }
  },
  methods: {
    handleStartAssessment() {
      // 检查是否已激活
      if (isActivated()) {
        // 已激活，直接跳转到测试类型选择页
        this.$router.push('/assessment/select-type')
      } else {
        // 未激活，显示激活码对话框
        this.targetRoute = '/assessment/select-type'
        this.showActivationDialog = true
      }
    },
    
    handleActivationClose() {
      this.showActivationDialog = false
    }
  }
}
</script>
